<div class="modal-header">
    <h4 class="modal-title">Selecciona una imagen</h4>
  </div>
  <div class="modal-body text-center">
    <img src="../../../../assets/images/logmeter.jpg" alt="Madera" class="img-thumbnail m-2" (click)="select('A')" />
    <img src="../../../../assets/images/bulkmeter.jpg" alt="Contenedor de Carga" class="img-thumbnail m-2" (click)="select('B')" />
  </div>
  